/**
 * Chat History Date Range Validation Constants
 */

// Minimum time range in hours
export const MIN_TIME_RANGE_HOURS = 1;

// Maximum time range in months
export const MAX_TIME_RANGE_MONTHS = 12;

// Date format for display
export const DATE_DISPLAY_FORMAT = "YYYY / MM / DD HH:mm";

// Date format for API (ISO 8601 with timezone)
export const DATE_API_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";
